module.exports = __webpack_public_path__ + "img/eu.871ae2e7.svg";